import { RootState } from '../../interfaces/rootState';

export const CaseListSelector = (r: RootState) => r.caseList;

export const CaseListCountSelector = ({ caseList }: RootState) => caseList.totalCount;

export const CaseListFilterSelector = ({ caseList }: RootState) => caseList.filter;
